/* tslint:disable */
import {
  Vendor,
  Product
} from '../index';

declare var Object: any;
export interface AddOnGroupInterface {
  "name": string;
  "updatedAt"?: Date;
  "updatedBy"?: any;
  "addons"?: Array<any>;
  "status"?: number;
  "id"?: any;
  "vendorId"?: any;
  vendor?: Vendor;
  product?: Product[];
}

export class AddOnGroup implements AddOnGroupInterface {
  "name": string;
  "updatedAt": Date;
  "updatedBy": any;
  "addons": Array<any>;
  "status": number;
  "id": any;
  "vendorId": any;
  vendor: Vendor;
  product: Product[];
  constructor(data?: AddOnGroupInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AddOnGroup`.
   */
  public static getModelName() {
    return "AddOnGroup";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AddOnGroup for dynamic purposes.
  **/
  public static factory(data: AddOnGroupInterface): AddOnGroup{
    return new AddOnGroup(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AddOnGroup',
      plural: 'addOnGroups',
      path: 'addOnGroups',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'any'
        },
        "addons": {
          name: 'addons',
          type: 'Array&lt;any&gt;'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "vendorId": {
          name: 'vendorId',
          type: 'any'
        },
      },
      relations: {
        vendor: {
          name: 'vendor',
          type: 'Vendor',
          model: 'Vendor',
          relationType: 'belongsTo',
                  keyFrom: 'vendorId',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product[]',
          model: 'Product',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'addOnGroupId'
        },
      }
    }
  }
}
